/**
 * The vehicle commands that take no arguments beyond the vehicle id, which makes them the ones
 * that can be run on several vehicles at once. The remaining commands from the vehicle details
 * page are deliberately left out: `set status` needs a state per run, `replace iot` needs a
 * unique imei per vehicle and `see vuf` is read-only.
 */
export type VehicleCommand =
    | 'unlock'
    | 'lock'
    | 'open-hatch'
    | 'update-version'
    | 'reboot-iot'
    | 'reboot-ccu'
    | 'sound-alarm'
    | 'take-ownership'
    | 'give-up-ownership'
    | 'unlock-and-own'
    | 'lock-and-release'

export const VEHICLE_COMMAND_OPTIONS: VehicleCommand[] = [
    'unlock',
    'lock',
    'open-hatch',
    'update-version',
    'reboot-iot',
    'reboot-ccu',
    'sound-alarm',
    'take-ownership',
    'give-up-ownership',
]

/**
 * The event manager role runs the atomic ride-style commands instead of the plain lock/unlock:
 * unlocking takes ownership first and locking releases it again
 */
export const EVENT_VEHICLE_COMMAND_OPTIONS: VehicleCommand[] = ['unlock-and-own', 'lock-and-release']

export const VEHICLE_COMMAND_LABELS: Record<VehicleCommand, string> = {
    unlock: 'Unlock',
    lock: 'Lock',
    'open-hatch': 'Open hatch',
    'update-version': 'Update version',
    'reboot-iot': 'Reboot IoT',
    'reboot-ccu': 'Reboot CCU',
    'sound-alarm': 'Sound alarm',
    'take-ownership': 'Take ownership',
    'give-up-ownership': 'Give up ownership',
    'unlock-and-own': 'Unlock',
    'lock-and-release': 'Lock',
}
